<div class="layout-col full">
  <span style="width: 90vw"></span>

  <app-process-plan-detail class="flex" [processPlan]="processPlan" (close)="onClose($event)">
  </app-process-plan-detail>
</div>
